import styles from "../../../Main.module.css";
import solutionHeaders from "../../../utils/data/solutionHeaders.json";
import LicenseTag from "../../../../../components/LicenseTag";

import {
  Button,
  Select,
  Input,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  ModalFooter,
  Editable,
  EditablePreview,
  EditableInput,
  Switch,
} from "@chakra-ui/react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import {
  IconButton,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
} from "@chakra-ui/react";
import {
  AddIcon,
  CheckIcon,
  CloseIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import { useState } from "react";

function ColumnManager({
  userInputs,
  projectData,
  columnGroupInputs,
  updateColumnGroupInputs,
  columnInputs,
  setColumnInputs,
  updateColumnInputs,
  updateColumnInputsCombs,
  formColumnGroup,
  setFormColumnGroup,
  formColumn,
  setFormColumn,
  onColumnGroupAction,
  onColumnAction,
}) {
  const [selectedComb, setSelectedComb] = useState("fz_max");
  const [considerCombs, setConsiderCombs] = useState(false);

  return (
    <>
      <Modal
        isOpen={formColumn}
        onClose={() => {
          setFormColumn(false);
          updateColumnGroupInputs(
            "selected_name",
            columnGroupInputs["selected_name"]
          );
          setColumnInputs({
            selected_name:
              projectData["columns"][columnGroupInputs["selected_name"]][0][
                "name"
              ],
            name: "",
            combs:
              projectData["columns"][columnGroupInputs["selected_name"]][0][
                "combs"
              ],
          });
        }}
        size="2xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="md">LISTA DE PILARES</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <div className={styles.structureSectionRow2}>
              <Text marginRight="10px">Setor:</Text>
              <Select
                name="selected_name"
                onChange={(ev) =>
                  updateColumnGroupInputs("selected_name", ev.target.value)
                }
                variant="outline"
                w="200px"
                size="sm"
                fontSize="md"
                value={columnGroupInputs["selected_name"]}
              >
                {Object.keys(projectData["columns"])
                  .sort((a, b) => a.localeCompare(b))
                  .map((columnGroup, i) => (
                    <option key={i} value={columnGroup}>
                      {" "}
                      {columnGroup}{" "}
                    </option>
                  ))}
              </Select>
              <Popover
                placement="bottom"
                isOpen={formColumnGroup === "register"}
                onOpen={() => setFormColumnGroup("register")}
                onClose={() => setFormColumnGroup("")}
              >
                <PopoverTrigger>
                  <IconButton
                    variant="icon"
                    isDisabled={
                      userInputs["licenses"]["fundars"]["plan"] === "trial" ||
                      userInputs["licenses"]["fundars"]["plan"] === "basic"
                    }
                    icon={
                      <Tooltip
                        hasArrow
                        label={
                          userInputs["licenses"]["fundars"]["plan"] ===
                            "trial" ||
                          userInputs["licenses"]["fundars"]["plan"] ===
                            "basic" ? (
                            <span>
                              Para usar essa função habilite a licença{" "}
                              <LicenseTag plan="pro" /> ou uma superior
                            </span>
                          ) : (
                            "Criar"
                          )
                        }
                        bg="gray"
                        color="black"
                        fontSize="md"
                      >
                        <AddIcon />
                      </Tooltip>
                    }
                  />
                </PopoverTrigger>
                <PopoverContent flexDirection={"row"}>
                  <PopoverArrow backgroundColor={"black"} />
                  <Input
                    name="name_input"
                    type="text"
                    placeholder="Digite o nome da solução"
                    onChange={(ev) =>
                      updateColumnGroupInputs("name_input", ev.target.value)
                    }
                    value={columnGroupInputs["name_input"]}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CheckIcon />}
                    onClick={() => onColumnGroupAction(formColumnGroup)}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setFormColumnGroup("");
                      updateColumnGroupInputs("name_input", "");
                    }}
                  />
                </PopoverContent>
              </Popover>
              <Popover
                placement="bottom"
                isOpen={formColumnGroup === "edit"}
                onOpen={() => setFormColumnGroup("edit")}
                onClose={() => setFormColumnGroup("")}
              >
                <PopoverTrigger>
                  <IconButton
                    variant="icon"
                    icon={
                      <Tooltip
                        hasArrow
                        label="Editar"
                        bg="gray"
                        color="black"
                        fontSize="md"
                      >
                        <EditIcon />
                      </Tooltip>
                    }
                  />
                </PopoverTrigger>
                <PopoverContent flexDirection={"row"}>
                  <PopoverArrow backgroundColor={"black"} />
                  <Input
                    name="name_input"
                    type="text"
                    placeholder="Digite o nome da solução"
                    onChange={(ev) =>
                      updateColumnGroupInputs("name_input", ev.target.value)
                    }
                    value={columnGroupInputs["name_input"]}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CheckIcon />}
                    onClick={() => onColumnGroupAction(formColumnGroup)}
                  />
                  <IconButton
                    variant="icon"
                    icon={<CloseIcon />}
                    onClick={() => {
                      setFormColumnGroup("");
                      updateColumnGroupInputs("name_input", "");
                    }}
                  />
                </PopoverContent>
              </Popover>
              <IconButton
                variant="icon"
                icon={
                  <Tooltip
                    hasArrow
                    label="Remover"
                    bg="gray"
                    color="black"
                    fontSize="md"
                  >
                    <DeleteIcon />
                  </Tooltip>
                }
                onClick={() => setFormColumnGroup("remove")}
              />
            </div>
            <div className={styles.structureColumnCombsSection}>
              <Table variant="simple">
                <Thead>
                  <Tr key={"column-comb-header"}>
                    <Th fontSize="md" key="column-comb">
                      Comb.
                    </Th>
                    <Th fontSize="md" key="column-comb-fz">
                      Fz (tf)
                    </Th>
                    <Th fontSize="md" key="column-comb-fx">
                      Fx (tf)
                    </Th>
                    <Th fontSize="md" key="column-comb-fy">
                      Fy (tf)
                    </Th>
                    <Th fontSize="md" key="column-comb-mx">
                      Mx (tf.m)
                    </Th>
                    <Th fontSize="md" key="column-comb-my">
                      My (tf.m)
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {considerCombs ? (
                    Object.entries(columnInputs["combs"]).map(
                      ([combName, comb], i) => (
                        <Tr
                          key={"row-" + combName}
                          sx={{
                            _hover: {
                              td: {
                                color: "var(--text-color) !important",
                              },
                            },
                          }}
                        >
                          <Td key={combName}>
                            <strong>
                              {{
                                fz_max: "Fz,máx",
                                fz_min: "Fz,mín",
                                mx_max: "Mx,máx",
                                my_max: "My,máx",
                              }[combName] || combName}
                            </strong>
                          </Td>
                          {Object.keys(comb).map((key, j) => (
                            <Td key={combName + key} w="100%">
                              <Editable
                                w="100%"
                                h="100%"
                                value={columnInputs["combs"][combName][
                                  key
                                ].toString()}
                              >
                                <EditablePreview h="100%" />
                                <EditableInput
                                  h="100%"
                                  onKeyPress={(event) => {
                                    const {
                                      selectionStart,
                                      selectionEnd,
                                      value,
                                    } = event.target;
                                    const newValue =
                                      value.slice(0, selectionStart) +
                                      event.key +
                                      value.slice(selectionEnd);
                                    if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  onChange={(ev) =>
                                    updateColumnInputsCombs(
                                      combName,
                                      key,
                                      ev.target.value
                                    )
                                  }
                                  onBlur={(ev) => {
                                    if (
                                      ev.target.value === "" ||
                                      ev.target.value === "." ||
                                      ev.target.value === "-" ||
                                      ev.target.value.endsWith("-.") ||
                                      ev.target.value.endsWith("-0") ||
                                      ev.target.value.endsWith("-0.") ||
                                      ev.target.value.endsWith("-.0") ||
                                      ev.target.value.endsWith("-0.0")
                                    ) {
                                      updateColumnInputsCombs(
                                        combName,
                                        key,
                                        "0"
                                      );
                                    } else if (ev.target.value.endsWith(".")) {
                                      updateColumnInputsCombs(
                                        combName,
                                        key,
                                        ev.target.value.slice(0, -1)
                                      );
                                    } else if (ev.target.value.endsWith(".0")) {
                                      updateColumnInputsCombs(
                                        combName,
                                        key,
                                        ev.target.value.slice(0, -2)
                                      );
                                    }
                                  }}
                                />
                              </Editable>
                            </Td>
                          ))}
                        </Tr>
                      )
                    )
                  ) : (
                    <Tr
                      key="row-fz_max"
                      sx={{
                        _hover: {
                          td: {
                            color: "var(--text-color) !important",
                          },
                        },
                      }}
                    >
                      <Td key={"fz_max"}>
                        <strong>Fz,máx</strong>
                      </Td>
                      {Object.keys(columnInputs["combs"]["fz_max"]).map(
                        (key, j) => (
                          <Td key={"fz_max" + key} w="100%">
                            <Editable
                              w="100%"
                              h="100%"
                              value={columnInputs["combs"]["fz_max"][
                                key
                              ].toString()}
                            >
                              <EditablePreview h="100%" />
                              <EditableInput
                                h="100%"
                                onKeyPress={(event) => {
                                  const {
                                    selectionStart,
                                    selectionEnd,
                                    value,
                                  } = event.target;
                                  const newValue =
                                    value.slice(0, selectionStart) +
                                    event.key +
                                    value.slice(selectionEnd);
                                  if (!/^-?\d*\.?\d{0,2}$/.test(newValue)) {
                                    event.preventDefault();
                                  }
                                }}
                                onChange={(ev) =>
                                  updateColumnInputsCombs(
                                    "fz_max",
                                    key,
                                    ev.target.value
                                  )
                                }
                                onBlur={(ev) => {
                                  if (
                                    ev.target.value === "" ||
                                    ev.target.value === "." ||
                                    ev.target.value === "-" ||
                                    ev.target.value.endsWith("-.") ||
                                    ev.target.value.endsWith("-0") ||
                                    ev.target.value.endsWith("-0.") ||
                                    ev.target.value.endsWith("-.0") ||
                                    ev.target.value.endsWith("-0.0")
                                  ) {
                                    updateColumnInputsCombs("fz_max", key, "0");
                                  } else if (ev.target.value.endsWith(".")) {
                                    updateColumnInputsCombs(
                                      "fz_max",
                                      key,
                                      ev.target.value.slice(0, -1)
                                    );
                                  } else if (ev.target.value.endsWith(".0")) {
                                    updateColumnInputsCombs(
                                      "fz_max",
                                      key,
                                      ev.target.value.slice(0, -2)
                                    );
                                  }
                                }}
                              />
                            </Editable>
                          </Td>
                        )
                      )}
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </div>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Switch
                  isChecked={considerCombs}
                  onChange={() => {
                    if (considerCombs) {
                      setConsiderCombs(false);
                    } else {
                      setConsiderCombs(true);
                    }
                  }}
                />
                <Text fontSize="md" paddingLeft="10px">
                  Considerar múltiplas combinações
                </Text>
              </div>
            </div>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">Numeração=</Text>
                <Input
                  name="name"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(ev) => updateColumnInputs("name", ev.target.value)}
                  width="50px"
                  size="xs"
                  fontSize="md"
                  value={columnInputs["name"]}
                />
              </div>
              <Tooltip
                placement="bottom"
                isDisabled={
                  userInputs["licenses"]["fundars"]["plan"] !== "trial" &&
                  userInputs["licenses"]["fundars"]["plan"] !== "basic"
                }
                label={
                  <span>
                    Para usar essa função habilite a licença{" "}
                    <LicenseTag plan="pro" /> ou uma superior
                  </span>
                }
              >
                <Button
                  name="column_register"
                  width="100px"
                  isDisabled={
                    userInputs["licenses"]["fundars"]["plan"] === "trial" ||
                    userInputs["licenses"]["fundars"]["plan"] === "basic"
                  }
                  onClick={() => {
                    onColumnAction("register");
                  }}
                  colorScheme="blue"
                  size="sm"
                  fontSize="md"
                >
                  Cadastrar
                </Button>
              </Tooltip>
              <Button
                name="column_edit"
                width="100px"
                onClick={() => {
                  onColumnAction("edit");
                }}
                colorScheme="blue"
                size="sm"
                fontSize="md"
              >
                Editar
              </Button>
              <Button
                name="column_remove"
                width="100px"
                onClick={() => {
                  onColumnAction("remove");
                }}
                colorScheme="blue"
                size="sm"
                fontSize="md"
              >
                Remover
              </Button>
            </div>
            <div className={styles.structureModalSection}>
              <Table variant="simple">
                <Thead>
                  <Tr key={"header"}>
                    {solutionHeaders["columns"]["headers"].map((header, i) => (
                      <Th fontSize="md" key={"head-" + i}>
                        {header}
                      </Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {projectData["columns"][
                    columnGroupInputs["selected_name"]
                  ].map((column, j) => (
                    <Tr
                      aria-selected={
                        columnInputs["selected_name"] === column["name"]
                          ? "true"
                          : "false"
                      }
                      key={"row-" + j}
                    >
                      {solutionHeaders["columns"]["values"].map((value, i) => (
                        <Td
                          key={"col-" + value + "-" + j}
                          onClick={() => {
                            updateColumnInputs("selected_name", column["name"]);
                          }}
                        >
                          {value === "name"
                            ? column[value]
                            : column["combs"][selectedComb][value]}
                        </Td>
                      ))}
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </div>
            <div className={styles.structureSectionRow}>
              <div className={styles.structureSectionElement}>
                <Text fontSize="md">Combinação=</Text>
                <Select
                  name="combination"
                  onChange={(ev) => setSelectedComb(ev.target.value)}
                  variant="outline"
                  w="100px"
                  size="xs"
                  fontSize="md"
                  value={selectedComb}
                >
                  <option key={"comb" + 0} value={"fz_max"}>
                    Fz,máx
                  </option>
                  <option key={"comb" + 1} value={"fz_min"}>
                    Fz,mín
                  </option>
                  <option key={"comb" + 2} value={"mx_max"}>
                    Mx,máx
                  </option>
                  <option key={"comb" + 3} value={"my_max"}>
                    My,máx
                  </option>
                </Select>
              </div>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
      {formColumnGroup === "remove" && (
        <Modal isCentered isOpen={formColumnGroup !== ""}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>
              Excluir {columnGroupInputs["selected_name"]}
            </ModalHeader>
            <ModalCloseButton
              onClick={() => {
                setFormColumnGroup("");
              }}
            />
            <ModalBody>
              Deseja prosseguir? Essa ação não poderá ser desfeita
            </ModalBody>
            <ModalFooter>
              <Button
                variant="delete"
                onClick={() => onColumnGroupAction(formColumnGroup)}
              >
                EXCLUIR
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
}

export default ColumnManager;
